/*
 * @Author: Teemo Ding
 * @Date: 2022-02-14 16:01:29
 * @LastEditTime: 2022-06-06 10:15:54
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/List/index.tsx
 */

import { NoDataPage } from '@/src/components';
import { Skeleton } from '@/src/components/Antd';
import EditableTable from '@/src/components/EditableTable/EditableTable';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import {
  deleteCommunicationGateway,
  getCommunicationGateways,
} from '@/src/request/settings/communication';
import { IMAGE_BASE_URL } from '@/src/tools/config';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  CommunicationChannelType,
  CommunicationGatewayProvider,
} from '@/src/types/common/communication';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
import { NEW } from 'src/tools/constant';
import { i18nGet } from 'src/tools/tools';
import { modal } from 'src/utils/Modal';
import AddPaymentModal from '../../Components/AddPaymentModal/AddPaymentModal';
import { calculateCommunication } from '../tool';
import { breadcrumbData, columns } from './config';

// import { Icon } from '@/src/tools/icon';
// import css from './css.module.less';
const allGateway = [
  {
    gateway: CommunicationGatewayProvider.Twilio,
    channelType: CommunicationChannelType.SMS,
  },
  {
    gateway: CommunicationGatewayProvider.Twilio,
    channelType: CommunicationChannelType.WhatsApp,
  },
  // {
  //   gateway: CommunicationGatewayProvider.Twilio,
  //   channelType: CommunicationChannelType.PhoneNumberValidation,
  // },
  {
    gateway: CommunicationGatewayProvider.Cloopen,
    channelType: CommunicationChannelType.SMS,
  },
  {
    gateway: CommunicationGatewayProvider.Sendgrid,
    channelType: CommunicationChannelType.Email,
  },
  {
    gateway: CommunicationGatewayProvider.Zhima,
    channelType: CommunicationChannelType.LiveChat,
  },
];

const permissions = () => {
  const add_edit_communication_gateway = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsCommunication,
        operation: EnumOperation.add_edit_communication_gateway,
      }),
    ],
  });
  const delete_communication_gateway = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsCommunication,
        operation: EnumOperation.delete_communication_gateway,
      }),
    ],
  });
  const view_communication_gateways_listing_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsCommunication,
        operation: EnumOperation.view_communication_gateways_listing_page,
      }),
    ],
  }); //view_communication_gateway_details_page
  const view_communication_gateway_details_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsCommunication,
        operation: EnumOperation.view_communication_gateway_details_page,
      }),
    ],
  });
  return {
    add_edit_communication_gateway,
    delete_communication_gateway,
    view_communication_gateways_listing_page,
    view_communication_gateway_details_page,
  };
};

const CommunicationList = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    add_edit_communication_gateway,
    delete_communication_gateway,
    view_communication_gateways_listing_page,
    view_communication_gateway_details_page,
  } = permissions();
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent },
  } = props;
  const [loading, setLoading] = useState(true);
  const [communicationGateways, setCommunicationGateways] = useState([]);
  const history = useHistory();

  useEffect(() => {
    if (view_communication_gateways_listing_page) {
      getCommunicationGateways().then((res: any) => {
        setCommunicationGateways(res || []);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  const handleAddConfirm = (newProvider) => {
    const gateway = newProvider.split('-')[0];
    const channelType = newProvider.split('-')[1];
    const params = (communicationGateways || []).filter(
      (o) => o?.gatewayProvider == gateway && o?.channelType == channelType,
    );
    history.push(
      `/settings/communicationDetail/${gateway}/${channelType}/${NEW}?length=${
        params.length ? params.length + 1 : 1
      }`,
    );
  };

  const addFun = () => {
    setShowModal(true);
    setModalTitle(
      getI18n('storeCommunicationSetting.list.addCommunicationGateway'),
    );
    setModalContent(
      <AddPaymentModal
        setShowModal={setShowModal}
        inputPlaceHolder={getI18n(
          'storeCommunicationSetting.list.searchCommunicationGateway',
        )}
        defaultRadioItem={allGateway.map((item) => {
          const indexGateway = calculateCommunication(
            item.gateway,
            item.channelType,
            {
              getI18n,
            },
          );
          return {
            label: '',
            value: `${item.gateway}-${item.channelType}`,
            disable: false,
            image: `${IMAGE_BASE_URL}/communication/${item.gateway}.png`,
            description: `${getI18n(
              'storeCommunicationSetting.list.communicationchannel',
            )}: ${indexGateway.channelType}`,
            title: indexGateway.gateway,
          };
        })}
        paymentList={communicationGateways}
        onConfirm={handleAddConfirm}
      />,
    );
  };
  const pageLayoutProps = {
    title: getI18n('storeCommunicationSetting.list.communicationGateway'),
    addText: add_edit_communication_gateway
      ? getI18n('storeCommunicationSetting.list.addCommunicationGateway')
      : null,
    addFun: add_edit_communication_gateway ? addFun : null,
    activeKey: '',
    tabsConfig: [{ name: getI18n('general.all'), key: '' }],
  };
  const editAction = (record) => {
    history.push(
      `/settings/communicationDetail/${record.gatewayProvider}/${record.channelType}/${record.uuid}`,
    );
  };

  const handleDeletePaymentGateway = (record) => {
    deleteCommunicationGateway(record.uuid).then(() => {
      message.success(getI18n('general.deletedsuccessfully'));
      getCommunicationGateways().then((data) => {
        setCommunicationGateways(data || []);
      });
    });
  };

  const deleteAction = (record) => {
    modal.error({
      title: record.deletable
        ? getI18n('storeCommunicationSetting.list.deletableTitle')
        : getI18n('storeCommunicationSetting.list.unableDeletableTitle'),
      content: record.deletable
        ? getI18n('storeCommunicationSetting.list.deletableContent')
        : getI18n('storeCommunicationSetting.list.unableDeletableContent'),
      onOkText: record.deletable
        ? getI18n('general.delete')
        : getI18n('general.antd.Uploader.ok'),
      onOk: record.deletable
        ? () => handleDeletePaymentGateway(record)
        : () => void 0,
      ...(record.deletable
        ? {
            onCancel: () => {
              return;
            },
          }
        : {}),
    });
  };
  const child = [
    {
      child: (
        <div>
          {communicationGateways.length == 0 ? (
            <NoDataPage
              title={getI18n('storeCommunicationSetting.list.noDataPageTitle')}
              introduce={getI18n(
                'storeCommunicationSetting.list.noDataPageIntroduce',
              )}
              buttonTitle={getI18n(
                'storeCommunicationSetting.list.noDataPageButtonTitle',
              )}
              onClick={addFun}
              disabled={!add_edit_communication_gateway}
            />
          ) : (
            <ListPageLayout {...pageLayoutProps}>
              <EditableTable
                disableAdd
                data={communicationGateways}
                columns={columns(
                  editAction,
                  deleteAction,
                  !view_communication_gateway_details_page,
                  !delete_communication_gateway,
                  { getI18n },
                )}
                id='PaymentListTable'
                rowKey='uuid'
              />
            </ListPageLayout>
          )}
        </div>
      ),
    },
  ];

  const goBackToList = () => {
    history.push({
      pathname: '/settings',
    });
  };

  const topLeft = (
    <TopLeft
      goBack={goBackToList}
      breadcrumbData={breadcrumbData({ getI18n })}
    />
  );
  return (
    <Skeleton loading={loading} active>
      <Layout elements={child} topLeft={topLeft}></Layout>
    </Skeleton>
  );
};

export default ModalHoc(CommunicationList);
